export function initialPasswordError(password, confirmation) {
  if (password !== confirmation) return "De wachtwoorden komen niet overeen.";
  if (password.length < 12) return "Gebruik minimaal 12 tekens.";
  if (!/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/[0-9]/.test(password)) {
    return "Gebruik kleine letters, hoofdletters en cijfers.";
  }
  if (!/[^A-Za-z0-9]/.test(password)) return "Gebruik minimaal één speciaal teken.";
  return null;
}
